import { combineEpics } from "redux-observable";
import applicationEpic from "application/redux/applicationEpic";
import authEpic from "auth/authEpic";
import browseMediaEpic from "browse-media/redux/browseMediaEpic";
import editMediaEpic from "edit-media/redux/editMediaEpic";
import manageModulesEpic from "manage-modules/redux/manageModulesEpic";

export default combineEpics(
  applicationEpic,
  authEpic,
  browseMediaEpic,
  editMediaEpic,
  manageModulesEpic,
);
